module.exports = __webpack_public_path__ + "img/stick_activites_speleologie.43cc072f.svg";